<template>
    <div>
        <div class="mask" v-show="isLoginShow">
            <div class="popUps">
                <div class="closeBtn" @click="closeBtn"><img src="../images/home/close.png" alt=""></div>
                    <div class="loginImg">
                        <img src="../images/home/login_img.png" alt="">
                    </div>
                <template v-if="loginRegister">
                    <div class="rightList">
                        <div class="centerList">
                            <div class="loginTitle">您好，<em>请登录</em></div>
                            <ul class="loginList">
                                <li>
                                    <p>用户名</p>
                                    <input type="text" placeholder="请输入用户名" v-model="userInfo.name" maxlength="20">
                                </li>
                                <li>
                                    <p>密码</p>
                                    <input type="password" v-model="userInfo.password" placeholder="请输入密码" maxlength="20">
                                </li>
                                <li class="codeBox">
                                    <p>验证码</p>
                                    <input type="text" v-model="code" placeholder="请输入验证码" maxlength="6">
                                    <div class="codeImg"><VerificationCode ref="verCode" @update:changeCode="changeCodeBtn"></VerificationCode></div>
                                </li>
                            </ul>
                            <div class="submitBtn" @click="submitLoginBtn">登 录</div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="rightList">
                        <div class="centerList">
                            <div class="loginTitle">您好，<em>请注册</em></div>
                            <ul class="loginList">
                                <li>
                                    <p>用户名</p>
                                    <input type="text" v-model="userInfo.name" placeholder="请输入用户名" maxlength="20">
                                </li>
                                <li>
                                    <p>密码</p>
                                    <input type="password" v-model="userInfo.password" placeholder="请输入密码" maxlength="20">
                                </li>
                                <li>
                                    <p>确诊密码</p>
                                    <input type="password" v-model="verifyPassword" placeholder="请输入确诊密码" maxlength="20">
                                </li>
                                <!-- <li>
                                    <p>邮箱</p>
                                    <input type="password" placeholder="请输入邮箱" maxlength="30">
                                </li> -->
                                <li class="codeBox">
                                    <p>验证码</p>
                                    <input type="text" v-model="code" placeholder="请输入验证码" maxlength="6">
                                    <div class="codeImg"><VerificationCode ref="verCode" @update:changeCode="changeCodeBtn"></VerificationCode></div>
                                </li>
                            </ul>
                            <div class="submitBtn" @click="submitRegisterBtn">注 册</div>
                        </div>
                    </div>
                </template>
            </div>
            <div class="closeMask" @click="closeBtn"></div>
        </div>
        <!-- TOAST -->
        <Tips ref="tipsLarey"></Tips>
    </div>
</template>

<script>
    import Tips from './tips';
    import VerificationCode from './VerificationCode';

    export default {
        name: '',
        data() {
            return {
                toastFixed: false,
                toast:'暂无内容',
                code: '',
                identifyCode: "",   // 当前生成的验证码
                verifyPassword:'',
                userInfo:{
                    name:'',
                    password:'',
                },
                userData: localStorage.getItem('userInfo') || [],
            }
        },
        watch:{
            // 监听是否关闭弹窗并清空input框
            isLoginShow(e){
                if(!e){
                    this.code = '';
                    this.verifyPassword = '';
                    this.userInfo = {
                        name:'',
                        password:'',
                    };
                }else{
                    // 切换验证码
                    this.$refs.verCode.changeCode();
                }
            },
        },
        methods:{
            // 登录-按钮
            submitLoginBtn(){
                console.log('验证码: ',this.identifyCode);
                if(this.userData.length != 0){
                    if(this.isStatus()){
                        try {
                            JSON.parse(this.userData).forEach((val)=>{
                                if(val.name == this.userInfo.name){
                                    if(val.password == this.userInfo.password){
                                        if(this.code.toLocaleUpperCase() != this.identifyCode){
                                            this.$refs.tipsLarey.tipsShow('验证错误');
                                        }else{
                                            this.$refs.tipsLarey.tipsShow('登录成功');
                                            this.$emit('userStatusBtn',true,this.userInfo);
                                        }
                                    }else{
                                        throw new Error('1');
                                    }
                                }else{
                                    throw new Error('2');
                                }
                            })
                        } catch (error) {
                            if(error.message == '1'){
                                this.$refs.tipsLarey.tipsShow('用户名或密码错误');
                            }else if(error.message == '2'){
                                this.$refs.tipsLarey.tipsShow('用户不存在');
                            }
                        }
                    }
                }else{
                    if(this.isStatus()){
                        // console.log('用户名未注册')
                        this.$refs.tipsLarey.tipsShow('用户名未注册');
                    }
                }
            },
            // 注册-按钮
            submitRegisterBtn(){
                if(this.userData.length != 0){
                    try{
                        JSON.parse(this.userData).forEach((val)=>{
                            if(val.name == this.userInfo.name){
                                this.$refs.tipsLarey.tipsShow('用户已存在');
                                throw new Error();
                            }
                        })
                    }catch(e){
                        return;
                    }
                }
                if(this.isStatus()){
                    if(!this.loginRegister){
                        if(this.verifyPassword == ''){
                            this.$refs.tipsLarey.tipsShow('请输入确认密码');
                        }else if(this.userInfo.password != this.verifyPassword){
                            this.$refs.tipsLarey.tipsShow('请输入密码不一致');
                        }else{
                            this.$emit('isLoginShowBtn', false);
                            this.userData.push(this.userInfo);
                            localStorage.setItem('userInfo',JSON.stringify(this.userData));
                            this.$refs.tipsLarey.tipsShow('注册成功');
                        }
                    }
                }
            },
            // 判断登录是否为空
            isStatus(){
                if(this.userInfo.name == ''){
                    this.$refs.tipsLarey.tipsShow('请输入用户名');
                    return false;
                }else if(this.userInfo.password == ''){
                    this.$refs.tipsLarey.tipsShow('请输入密码');
                    return false;
                }else if(this.code == ''){
                    this.$refs.tipsLarey.tipsShow('请输入验证码');
                    return false;
                }else if(this.code.toLocaleUpperCase() != this.identifyCode){
                    this.$refs.tipsLarey.tipsShow('验证码错误');
                    return false;
                }else{
                    return true;
                }
            },
            // 获取验证码
            changeCodeBtn(e){
                this.identifyCode = e;
            },
            // 关闭-弹窗
            closeBtn(){
                this.$emit('isLoginShowBtn', false);
            },
        },
        props:{
            isLoginShow:{
                type: Boolean,
                default: false,
            },
            loginRegister: {
                type: Boolean,
                default: false,
            }
        },
        components: { 
            Tips,
            VerificationCode,
        },
    }
</script>

<style lang="scss" scoped>
    .mask{
        top:0;
        left:0;
        width:100%;
        height:100%;
        z-index: 1000;
        position: fixed;
        @include h-bgColor(rgba(0,0,0,0.75));
        .popUps{
            top:50%;
            left:50%;
            width:800px;
            min-height:450px;
            z-index: 1100;
            display: flex;
            position: fixed;
            overflow: hidden;
            @extend %place;
            @include h-radius(4px);
            @include h-bgColor(var(--colorFF));
            .closeBtn{
                top:10px;
                right:10px;
                z-index: 10;
                width:26px;
                cursor: pointer;
                position: absolute;
                transition: all 0.2s;
                transform: rotate(0deg);
                -webkit-transform: rotate(0deg);
                &:hover{
                    transform: rotate(180deg);
                    -webkit-transform: rotate(180deg);
                }
            }
            .loginImg{
                display: flex;
                align-items: center;
                justify-content: center;
                width:50%;
                @include h-bgColor(#365ef6); // 365ef6 f9faff
            }
            .rightList{
                width:50%;
                height:100%;
                display: flex;
                align-items: center;
                .centerList{
                    width:70%;
                    margin:60px auto 70px;
                    .loginTitle{
                        margin-bottom:20px;
                        @include h-fontSize(var(--login-title),20px,36px);
                        em{
                            font-size: 18px;
                        }
                    }
                    .loginList{
                        li{
                            margin-bottom:10px;
                            p{
                                margin-bottom: 5px;
                                @include h-fontSize(#676e7b,12px,20px);
                            }
                            input{
                                width:100%;
                                height:34px;
                                text-indent: 10px;
                                @include h-radius(2px);
                                @include h-border(1px solid var(--login-input-b));
                                @include h-bgColor(var(--login-input-bg));
                                @include h-fontSize(var(--color33),13px,34px);
                                &::placeholder{
                                    color:var(--colorC3);
                                }
                            }
                        }
                        &:last-child{
                            margin-bottom:0;
                        }
                        .codeBox{
                            position: relative;
                            input{
                                width:66%
                            }
                            .codeImg{
                                bottom:0;
                                right:0;
                                width:83px;
                                height:34px;
                                z-index: 5;
                                cursor: pointer;
                                position: absolute;
                                span{
                                    display: block;
                                }
                            }
                        }
                    }
                    .submitBtn{
                        cursor: pointer;
                        margin:20px auto 0;
                        transition: background 0.3s;
                        @include h-btn(100%, 36px, 14px, $colorFF, 3px, 0, $colorF6, false, none);
                        &:hover{
                            @include h-bgColor($colorE7);
                        }
                    }
                }
            }
        }
        .closeMask{
            top:0;
            left:0;
            width:100%;
            height:100%;
            z-index: 990;
            position: fixed;
        }
    }
</style>